import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { SlimLoadingBarComponent } from 'ng2-slim-loading-bar';
import { ReservationService } from '../../services/reservation-service/reservation.service';
import { ErrorHandlerService } from '../../services/shared/error-handler.service';
import { removeNullishFieldsParams } from '../../shared/object_helpers';

@Component({
  selector: 'app-edit-customer-dialog',
  templateUrl: './edit-customer-dialog.component.html',
  styleUrls: ['./edit-customer-dialog.component.css']
})
export class EditCustomerDialogComponent implements OnInit {
  @ViewChild('customerForm') customerForm: NgForm;

  edit_lead_data: any = {
    lead_name: '',
    lead_phone: '',
    lead_code: '',
    lead_phone_without_code: '',
    lead_home_phone: '',
    lead_home_code: '',
    lead_home_phone_without_code: '',
    lead_other_phone: '',
    lead_other_code: '',
    lead_other_phone_without_code: '',
    lead_email: '',
    lead_national_id: '',
    lead_nationality: '',
    lead_birthday: '',
    lead_address: '',
    lead_district: '',
    lead_arabic_name: '',
    lead_issue_date: '',
    lead_job_title: '',
    lead_workplace: '',
    lead_phone_error: '',
    lead_other_phone_error: ''
  };

  isViewMode: boolean = false;
  dialogTitle: string = 'Edit Customer Info';
  reservationId: any;

  constructor(
    public dialogRef: MatDialogRef<EditCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService
  ) {
    if (data) {
      this.isViewMode = data.mode === 'view';
      this.reservationId = data.reservation_details.id
      this.dialogTitle = data.title || (this.isViewMode ? 'View Customer Info' : 'Edit Customer Info');

      // Copy customer data to edit_lead_data
      if (data.customer) {
        this.edit_lead_data = { ...this.edit_lead_data, ...data.customer };

        // Handle phone fields separately if they exist
        if (data.customer.lead_phone && !data.customer.lead_phone_without_code) {
          // Extract phone without code if full phone is provided
          this.extractPhoneComponents('lead_phone', data.customer.lead_phone);
        }
        if (data.customer.lead_home_phone && !data.customer.lead_home_phone_without_code) {
          this.extractPhoneComponents('lead_home_phone', data.customer.lead_home_phone);
        }
        if (data.customer.lead_other_phone && !data.customer.lead_other_phone_without_code) {
          this.extractPhoneComponents('lead_other_phone', data.customer.lead_other_phone);
        }
      }
    }
  }

  ngOnInit() {
  }

  private extractPhoneComponents(phoneField: string, fullPhone: string) {
    // This is a simplified extraction - you may need to adjust based on your data format
    // Assuming format like "+20 1234567890" or "+201234567890"
    const phoneRegex = /^\+?(\d{1,3})\s?(.+)$/;
    const match = fullPhone.match(phoneRegex);

    if (match) {
      const codeField = phoneField.replace('phone', 'code');
      const withoutCodeField = phoneField + '_without_code';

      this.edit_lead_data[codeField] = '+' + match[1];
      this.edit_lead_data[withoutCodeField] = match[2].replace(/\s/g, '');
    }
  }

  receivePhone(event: any, phone: string, code: string, err: string) {
    this.edit_lead_data[err] = event.phoneError;
    this.edit_lead_data[phone] = event.phone;
    this.edit_lead_data[code] = event.code;
    console.log('Received phone:', event, this.edit_lead_data);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    // Validate phone fields
    if (this.edit_lead_data['lead_phone_error']) {
      swal('Invalid Primary Phone', this.edit_lead_data['lead_phone_error'] || 'Please enter a valid phone number', 'error');
      return;
    }

    if (this.edit_lead_data['lead_other_phone_error']) {
      swal('Invalid Secondary Phone', 'Please enter a valid secondary phone number', 'error');
      return;
    }

    // Validate required fields
    if (!this.edit_lead_data.lead_name) {
      swal('Required Field', 'Customer name is required', 'error');
      return;
    }
    this.editLeadModalSubmit(this.edit_lead_data, this.dialogRef);
  }

    editLeadModalSubmit(lead, modal?) {
      let payload = lead;
      payload = removeNullishFieldsParams(payload);
      if (this.edit_lead_data['lead_phone_error']) {
        swal("Invalid Primary Phone", this.edit_lead_data['lead_phone_error'] || "Please enter a valid phone number", "error");
        return;
      }
      if (this.edit_lead_data['lead_other_phone_error']) {
        swal("Invalid Third Phone", this.edit_lead_data['lead_other_phone_error'] || "Please enter a valid phone number", "error");
        return;
      }
      console
      this.reservationService
        .editLeadInReservation(this.reservationId, payload)
        .subscribe(
          (res: any) => {
            swal("Success", "Customer information updated successfully", "success");
            modal.close(lead);
          },
          (err) => this.errorHandlerService.handleErorr(err),
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/dialogs/edit-customer-dialog/edit-customer-dialog.component.ts